var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13678 4.25933C8.27832 4.01417 8.59181 3.93017 8.83696 4.07171L11.8636 5.81915C12.1088 5.96069 12.1928 6.27417 12.0512 6.51933L6.31769 16.4501C6.25124 16.5652 6.14268 16.65 6.01491 16.6866L3.59745 17.3789C3.31869 17.4587 3.02927 17.2916 2.95903 17.0103L2.34985 14.5705C2.31766 14.4416 2.3368 14.3052 2.40326 14.1901L8.13678 4.25933Z",
    fill: "#0080A3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5957,
    width: 4.52,
    height: 3.39,
    rx: 0.512568,
    transform: "rotate(30 10.5957 0)",
    fill: "#0080A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.0b3a937ab99604eb067d0a6b38114126.svg";
export { ForwardRef as ReactComponent };